import axios from 'axios';

const instance = axios.create({
  // baseURL: clientCredentials.apiHost, // Uncomment if needed
  headers: {
    'Content-Type': 'application/json',
  },
});

instance.interceptors.request.use((config) => {
  try {
    const storedToken = localStorage.getItem('auth_token');
    const parsed = JSON.parse(storedToken);
    if (parsed?.token) {
      config.headers.Authorization = `Bearer ${parsed.token}`;
    }
  } catch (err) {
    console.error('Error parsing token:', err);
    config.headers.Authorization = null;
  }
  return config;
});

instance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('auth_token');
      localStorage.clear();
      window.location = '/';
    // navigate('/dashboard/home', { replace: true });
    }
    return Promise.reject(error);
  }
);

export { instance };
